import { defineMessages } from 'react-intl';

export const messages: {
	heading: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	body: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	primaryAction: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	heading: {
		defaultMessage: 'Switch to CSS view',
		description: 'Heading for the Statuspage appearance spotlight',
		id: 'statuspage.appearance-spotlight.heading',
	},
	body: {
		defaultMessage: 'Customize with additional flexibility and advanced styling.',
		description: 'Body text for the Statuspage appearance spotlight',
		id: 'statuspage.appearance-spotlight.body',
	},
	primaryAction: {
		defaultMessage: 'Ok, got it',
		description: 'Primary action button for the Statuspage appearance spotlight',
		id: 'statuspage.appearance-spotlight.action',
	},
});
